function setupRecaptcha(form) {
  if (!form) return;

  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    try {
      await new Promise((resolve) => grecaptcha.ready(resolve));

      const token = await grecaptcha.execute(
        "6LeMLc4qAAAAADk0c9rMzNxJlWlfDlccbFacan0M",
        {
          action: "Register",
        }
      );
      if (!token) {
        console.log("No token, contact developer.");
        return;
      }

      const response = await fetch(
        "https://mb-tek-api-720021731990.us-central1.run.app/mbtek/google/recaptcha",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ token: token }),
        }
      );
      const data = await response.json();
      if (data.success) {
        form.submit();
      } else {
        console.log(
          "Error in reCAPTCHA validation: " + (data.message || "Invalid token.")
        );
        return;
      }
    } catch (error) {
      console.error("reCAPTCHA error:", error);
    }
  });
}

function checkForRegisterForms(container) {
  const mainForm = container.querySelector("#RegisterForm");
  if (mainForm && !mainForm.dataset.recaptchaAttached) {
    setupRecaptcha(mainForm);
    mainForm.dataset.recaptchaAttached = "true";
  }

  const cartForm = container.querySelector("#RegisterCartForm");
  if (cartForm && !cartForm.dataset.recaptchaAttached) {
    setupRecaptcha(cartForm);
    cartForm.dataset.recaptchaAttached = "true";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("nt_login_canvas");

  if (container) {
    checkForRegisterForms(container);

    const observer = new MutationObserver((mutations, obs) => {
      checkForRegisterForms(container);

      const mainForm = container.querySelector("#RegisterForm");
      const cartForm = container.querySelector("#RegisterCartForm");
      if (
        mainForm &&
        mainForm.dataset.recaptchaAttached === "true" &&
        cartForm &&
        cartForm.dataset.recaptchaAttached === "true"
      ) {
        obs.disconnect();
        console.log("Both forms detected, observer disconnected.");
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });
  } else {
    const mainForm = document.querySelector("#RegisterForm");
    const cartForm = document.querySelector("#RegisterCartForm");

    if (mainForm) {
      setupRecaptcha(mainForm);
    }
    if (cartForm) {
      setupRecaptcha(cartForm);
    }
  }
});
